const chartColors = {
  blue: '#2477ff',
  green: '#2d8515',
  orange: '#e49400',
  red: '#db2a34',
  purple: '#474D84',
  dark: '#040620',
  teal: '#4179cf',
  pink: '#e671b8',
  gray: '#d6dee5',
  default: '#595d78',
  textColor: '#e0e0e1',
  gridLineColor: '#040620'
};

export default {
  chartColors
}
